export const FROM_HISTORICO_KEY = 'fromHistorico';
export const MSG_HISTORICO_KEY = 'msgHistorico';

export const animationDuration = {
    show: 500,
    hide: 500
};

export const fadeAnimation = 'fade down';

export const slideAnimation = 'slide down';
